import React from 'react';
import { Field } from 'react-final-form';
import { FormFieldProps, TimepickerProps } from 'types/TextField';
import Datepicker from '../Datepicker';

function FormDatepicker( {
  field,
  value,
  validate,
  onChange,
  ...rest
}: TimepickerProps & FormFieldProps ) {
  return field
    ? (
      <Field
        name={field}
        validate={validate}
        render={( { input, meta } ) => {
          const isInvalid = ( meta.touched && !!meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );
          return (
            <Datepicker
              value={input.value}
              meta={meta}
              onChange={( newValue ) => {
                if ( onChange ) onChange( newValue );
                input.onChange( newValue );
              }}
              isInvalid={isInvalid}
              {...rest}
            />
          );
        }}
      />
    ) : (
      <Datepicker
        value={value}
        onChange={onChange}
        {...rest}
      />
    );
}

export default FormDatepicker;
